import { ChangeEvent, useEffect, useRef } from 'react';
import { FilterDefn, useFilter } from '../index';
import styled from 'styled-components6';
import { Body1 } from '../../../theme';
import { keyForOption } from './utils';

const FilterCheckListContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    input {
        margin: 0;
        margin-top: -1px;
        width: 18px;
        height: 18px;
    }
`;

const FilterCheckListLabel = styled.label`
    width: 100%;
    display: block;
    padding: var(--rwl-spacing-sm);
    user-select: none;
`;

type FilterChecklistProps = {
    option: FilterDefn;
    indeterminate?: boolean;
};

export const FilterChecklist = ({
    option,
    indeterminate = false,
}: FilterChecklistProps) => {
    const checkboxRef = useRef<HTMLInputElement>(null);

    const { appliedFilters, addAppliedFilter, removeAppliedFilter } =
        useFilter();

    useEffect(() => {
        if (checkboxRef.current) {
            checkboxRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);

    const values = option.valueList || [option.value];

    const isChecked = appliedFilters.some((filter) => values.includes(filter));
    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        e.target.checked
            ? values.forEach((value) => addAppliedFilter(value))
            : removeChildren(option);
    };

    function removeChildren(removedOption: FilterDefn) {
        const removedOptionValues = removedOption.valueList || [
            removedOption.value,
        ];
        // remove ourselves
        removedOptionValues.forEach((value) => removeAppliedFilter(value));

        // clear any child items we have
        if (removedOption.subFilters?.length) {
            removedOption.subFilters.forEach((subFilter) => {
                removeChildren(subFilter);
            });
        }
    }

    return (
        <FilterCheckListContainer>
            <input
                ref={checkboxRef}
                type="checkbox"
                role="checkbox"
                id={keyForOption(option)}
                checked={isChecked}
                onChange={onChange}
                style={{ cursor: 'pointer' }}
            />
            <FilterCheckListLabel htmlFor={keyForOption(option)}>
                <Body1>{option.title}</Body1>
            </FilterCheckListLabel>
        </FilterCheckListContainer>
    );
};
